import { useState } from "react";
import { useTranslation } from "react-i18next";
import { BenchmarksTab } from "../components/settings/BenchmarksTab";
import { ChangePasswordTab } from "../components/settings/ChangePasswordTab";

type Tab = "benchmarks" | "password";

export default function Settings() {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<Tab>("benchmarks");

  return (
    <section className="space-y-5">
      <div>
        <div
          className="text-xs font-semibold uppercase tracking-wider mb-1"
          style={{ color: "var(--muted)" }}
        >
          {t("nav.group_reports")}
        </div>
        <h1 className="text-2xl font-bold tracking-tight">{t("settings.title")}</h1>
      </div>

      <div className="border-b" style={{ borderColor: "var(--border)" }}>
        <div className="flex gap-1">
          <TabButton
            active={activeTab === "benchmarks"}
            onClick={() => setActiveTab("benchmarks")}
            label={t("settings.tabs.benchmarks")}
          />
          <TabButton
            active={activeTab === "password"}
            onClick={() => setActiveTab("password")}
            label={t("settings.tabs.password", { defaultValue: "Passwort" })}
          />
        </div>
      </div>

      <div>
        {activeTab === "benchmarks" && <BenchmarksTab />}
        {activeTab === "password" && <ChangePasswordTab />}
      </div>
    </section>
  );
}

function TabButton({
  active,
  onClick,
  label,
}: {
  active: boolean;
  onClick: () => void;
  label: string;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="px-4 py-2.5 text-sm font-medium border-b-2 -mb-px transition-colors"
      style={{
        color: active ? "var(--text)" : "var(--muted)",
        borderColor: active ? "var(--accent)" : "transparent",
      }}
    >
      {label}
    </button>
  );
}
